module.exports = __webpack_public_path__ + "img/403bf6b.png";